if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    let TitleIntro = document.getElementById('title_intro');
    let TextIntro = document.getElementById('text_intro');

    if (TextIntro && TitleIntro) {
        TitleIntro = TitleIntro.innerHTML;
        if(TextIntro.getElementsByTagName('p')[0]){
            TextIntro.getElementsByTagName('p')[0].innerHTML = '<span class="title-copy">'+TitleIntro+'</span>' + TextIntro.getElementsByTagName('p')[0].innerHTML;
        } else {
            TextIntro.innerHTML = '<p><span class="title-copy">'+TitleIntro+'</span>' + TextIntro.innerHTML +'</p>';
        }
    }
    //SUBNAVIGATION

$(".navigation ul.submenu li .active").closest(".inner").addClass("open");
$(".navigation ul.submenu li .active")
  .parents("li")
  .addClass("item-open");

$(".navigation li a").off("click").on("click", function (event) {
  if ($(this).parent().children(".sub-sub-menu").length > 0) {
    event.preventDefault();

    var submenu = $(this).next(".sub-sub-menu");

    if (submenu.hasClass("menu-open")) {
      $(this).closest(".inner").removeClass("open");
      $(this).parent().removeClass("item-open");

      submenu.slideUp(300).removeClass("menu-open");
    } else {
      $(".navigation li .sub-sub-menu.menu-open").slideUp(300).removeClass("menu-open");
      $(".navigation ul li").removeClass("item-open");
      $(".inner").removeClass("open");

      $(this).closest(".inner").addClass("open");
      $(this).parent().addClass("item-open");
      submenu.slideDown(300).addClass("menu-open");
    }
  }
});

$(".submenu__label, .sub-menu li").on("click", function (e) {
      $(".sub-menu").slideToggle();
});


    $('.sym-slides').slick({
        accessibility: true
    });

    $('.images-slides').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 500,
        fade: true,
        accessibility: true
    });

    $('.slider-slide').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true,
                }
            }
        ]
    });

    $('.carrousel-slide').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    adaptiveHeight: true,
                }
            }
        ]
    });

    $('.reviews-slider').slick({
        arrows: true,
        dots: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 700,
        fade: true,
        accessibility: true,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    dots: false,
                }
            }
        ]
    });

    $('.gallery-slider').slick({
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        speed: 500,
        fade: true,
        accessibility: false,
        responsive: [
            {
              breakpoint: 600,
              settings:{
                arrows:false
              }
            }
        ]
    });

    let ScrollDown = document.getElementsByClassName('js-scrolldown');
    if(ScrollDown.length > 0){
        ScrollDown[0].addEventListener('click', function(){
            animateto('intro');
        });
    }

    //FAQ
    setTimeout(function(){
        $('.tab-label').each(function(){
            let thisHeightTap = $(this).height() + 40;
            let thisHeight = $(this).next('.tab-content').height() + thisHeightTap;
            $(this).parent().animate({height: thisHeightTap + 'px'},400);
            if($(this).hasClass('open')){
                $(this).parent().animate({height: thisHeight + 'px'},400);
            }
        });
        $('.learn-more-btn').append('<div class="arrow"></div>');
    }, 400);

    $('.tab-label').click(function(){
        let currentclick = $(this);
        let thisHeightTap = $(this).height() + 40;

        let slideIndex = $(this).data('artwork');
        $(".accordion-slide").slick('slickGoTo', parseInt(slideIndex));

        if(!currentclick.hasClass('open')){
            $('.tab-label').each(function(){
                if($(this) !== currentclick ){
                    if($(this).hasClass('open')){
                        let thisHeight = $(this).height() + 40;
                        $(this).removeClass('open');
                        $(this).parent().animate({height: thisHeight + 'px'},400);
                    }
                }
            });
            currentclick.addClass('open');
            let thisHeight = $(this).next('.tab-content').height() + thisHeightTap;
            $(this).parent().animate({height: thisHeight + 'px'},400);
        } else {
            currentclick.removeClass('open');
            currentclick.parent().animate({height: thisHeightTap + 'px'},400);
        }
    });

    $('[data-fancybox]').fancybox({
        loop : true,
        backFocus: false,
        autoFocus: false,
    });

    

    let screenHeight = $(window).height();
    $('#home .top-img figure, #home .top-img video').css("height", screenHeight - 170);

    $(window).resize(function(){
        screenHeight = $(window).height();
        $('#home .top-img figure, #home .top-img video').css("height", screenHeight - 170);
    });

    $("input[name*=select_destination]").eq(0).attr("checked", "checked");


    $('.btn, .signup-btn').each(function() {
        let htmlString = $(this).text();
        $(this).html('<span>'+htmlString+'</span><span class="arrow-btn"><svg xmlns="http://www.w3.org/2000/svg" width="22.2333" height="11.6376" viewBox="0 0 22.2333 11.6376"><path d="M16.5734,0l-.7475,.7685,4.3839,4.5069H0v1.0873H20.2098l-4.3839,4.5063,.7475,.7686,5.6599-5.8188L16.5734,0Z"/></svg></span><span class="deco"></span>');
    });

    /*MOBILE MENU NAV
	****************************************************************/

    //Open Navigation
    $('#menu-btn').click(function(event) {
        $('html').addClass('hide-overflow');
        $('.navigation').addClass('open');
        $('.navigation').stop().animate({left:'0px'},{duration:300});
        if($('.navigation ul li a').hasClass('.item-open')){
            $(".item-open").get(0).scrollIntoView(false);
        }
    });

    $('.close-menu').click(function(event) {
        event.preventDefault();
        $('html').removeClass('hide-overflow');
        $('.navigation').removeClass('open');
        $('.navigation').stop().animate({left:'100%'},{queue:false,duration:300});
    });

    //SUBNAVIGATION

    // Open active sub-nav on load
    $('.navigation ul.submenu li .active').closest('.inner').addClass('open')
    $('.navigation ul.submenu li .active').parents().parents('li').addClass('item-open');
    $('.navigation ul.submenu li .active').closest('.sub-sub-menu').slideDown(300, function() {}).addClass('menu-open');

    //Toggle open/close on tap
    $('.navigation li a').off('click').on('click', function(event) {
        if ( $(this).parent().children(".sub-sub-menu").length > 0 ) {

            event.preventDefault();

            if ($(this).next().hasClass('menu-open')) {
                $(this).closest('.inner').removeClass('open');
                $('.navigation ul li').removeClass('item-open');
                $(this).parent().addClass('item-open');
                $(this).next().slideUp(300, function(){
                    if($('.navigation ul li a').hasClass('active')){
                        $(".item-open").get(0).scrollIntoView(false);
                    }
                }).removeClass('menu-open');
            } else {
                $(this).closest('.inner').addClass('open');
                $('.navigation ul li').removeClass('item-open');
                $(this).parent().addClass('item-open');
                $('.sub-sub-menu.menu-open').slideUp(300).removeClass('menu-open');
                $(this).next().addClass('menu-open').slideDown(300, function(){
                    if($('.navigation ul li a').hasClass('active')){
                        $(".item-open").get(0).scrollIntoView(false);
                    }
                });
            }
        }
    });
})();

function animateto(target){
    /*var gotoTarget = offset(document.getElementById(target)).top - 130;
    var from     = window.pageYOffset
    var to       = gotoTarget
    var duration = 1300;
    var start = new Date().getTime()

    //time interval
    var timer = setInterval(function() {
        var time = new Date().getTime() - start

        if(from <= to ){
            var y = easeInOutQuart(time, from, to - from, duration)
        } else {

            var y = easeInOutQuart(time, from, -(from - to), duration)
        }
        window.scrollTo(0, y)
        if (time >= duration) clearInterval(timer)

    }, 1000 / 60);

    window.scrollTo(0, from)*/

}
//ease movement
function easeInOutQuart(t, b, c, d) {
    /*if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;*/
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

document.addEventListener('DOMContentLoaded', () => {
    let idItem = window.location.hash.substring(1)
    if(idItem){
        const target = document.getElementById(idItem);
        if( target ){
            setTimeout(() => {
                target.scrollIntoView({ 
                    behavior: "smooth", 
                    block: "center"
                });
            }, 500);
        }
    } 
});